import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SearchContextType {
  isMobileSearchVisible: boolean;
  toggleMobileSearch: () => void;
  hideMobileSearch: () => void;
  showMobileSearch: () => void;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error('useSearch must be used within a SearchProvider');
  }
  return context;
};

interface SearchProviderProps {
  children: ReactNode;
}

export const SearchProvider: React.FC<SearchProviderProps> = ({ children }) => {
  const [isMobileSearchVisible, setIsMobileSearchVisible] = useState(false);
  const location = useLocation();

  // Nasconde la ricerca quando si naviga via dalla homepage (solo mobile)
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    if (location.pathname !== '/' && isMobile) {
      setIsMobileSearchVisible(false);
    }
  }, [location.pathname]);

  const toggleMobileSearch = () => {
    setIsMobileSearchVisible(prev => !prev);
  };

  const hideMobileSearch = () => {
    setIsMobileSearchVisible(false);
  };

  const showMobileSearch = () => {
    setIsMobileSearchVisible(true);
  };

  return (
    <SearchContext.Provider value={{
      isMobileSearchVisible,
      toggleMobileSearch,
      hideMobileSearch,
      showMobileSearch
    }}>
      {children}
    </SearchContext.Provider>
  );
};